<template>
  <div id="secure">
    <navbar @logout="logout"></navbar>
  </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue';
import EventBus from '../utils/event-bus';

export default {
  name: 'Secure',
  data () {
    return {};
  },
  components: {
    Navbar
  },
  methods: {
    logout () {
      EventBus.$emit('logout');
    }
  }
};
</script>

<style scoped>

</style>
